import { render, staticRenderFns } from "./AddEditSchool.vue?vue&type=template&id=44b15ae3&scoped=true"
import script from "./AddEditSchool.vue?vue&type=script&lang=js"
export * from "./AddEditSchool.vue?vue&type=script&lang=js"
import style0 from "./AddEditSchool.vue?vue&type=style&index=0&id=44b15ae3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b15ae3",
  null
  
)

export default component.exports